module.exports = __webpack_public_path__ + "static/media/YM82_6.cb8092ab.jpg";